import { DeviceBadge } from '@/components/shared/DeviceBadge/DeviceBadge.tsx';

import cn from './style.module.sass';

interface IRightContentProps {
    price?: string;
    deviceType?: string;
}

export const RightContent = ({ price, deviceType }: IRightContentProps) => {
    return (
        <div className={cn.rightContent}>
            <span className={cn.price}>{price}</span>
            {deviceType && <DeviceBadge device={deviceType} />}
        </div>
    );
};
